const routes = {
  home: {
    title: 'Home',
    path: '/',
    linkId: '001',
  },
  bag: {
    title: 'Bag',
    path: '/bag',
    linkId: '002',
  },
  login: {
    title: 'Login',
    path: '/login',
    linkId: '003',
  },
  contactUs: {
    title: 'Contact us',
    path: '/g/contactus',
    linkId: '004',
  },
  feedBack: {
    title: 'Feedback',
    path: 'https://secure.opinionlab.com/ccc01/comment_card_d.asp',
    linkId: '005',
    opinionLab: 'oo_feedback',
  },
  findOrder: {
    title: 'Order Tracking',
    path: '/g/track',
    linkId: '006',
  },
  findStore: {
    title: 'Find a Store',
    path: 'https://stores.express.com/search',
    linkId: '007',
  },
  giftCards: {
    title: 'Gift Cards',
    path: '/g/gift-cards',
    linkId: '008',
  },
  help: {
    title: 'Help',
    path: '/g/help',
    linkId: '009',
  },
  next: {
    benefits: {
      title: 'Benefits',
      path: '/g/next/program-benefits',
      linkId: '010',
    },
    signIn: {
      title: 'Pay Your Bill',
      path: 'https://c.comenity.net/express/',
      linkId: '011',
    },
    signUp: {
      title: 'EXPRESS Next Credit Card',
      // should be updated, url not provided yet
      path: '/service/custserv.jsp?name=express_next_cc',
      linkId: '012',
    },
    nextCard: {
      title: 'EXPRESS Next Credit Card',
      path: '/my-account/express-next-credit-card',
      linkId: '013',
    },
  },
  signUp: {
    title: 'Sign Up',
    path: '/register',
    linkId: '014',
  },
  trackOrder: {
    title: 'Track Order',
    path: '/my-account/online-orders',
    linkId: '015',
  },
  myAccount: {
    title: 'Account Overview',
    path: '/my-account',
    linkId: '016',
  },
  onlineOrder: {
    title: 'Orders & Returns',
    path: '/my-account/online-orders',
    linkId: '017',
  },
  referAFriend: {
    title: 'Refer & Earn',
    path: '/referafriend?ICID=MM_MA_LEFTNAV',
    linkId: '018',
  },
  rewards: {
    title: 'Earn Rewards',
    path: '/my-account/my-rewards',
    linkId: '019',
  },
  terms: {
    title: 'Terms & Conditions',
    path: '/g/terms-conditions.html',
    linkId: '020',
  },
  privacy: {
    title: 'Privacy Policy',
    path: '/g/privacy-policy',
    linkId: '021',
  },
  availableOffers: {
    insiderBonus: {
      title: 'Reward Points',
      path: '/my-account/my-rewards',
      linkId: '022',
    },
    couponsPage: {
      title: 'Coupons Page',
      path: '/g/coupons',
      linkId: '023',
    },
  },
  signOut: {
    title: 'Sign Out',
    path: '/logout',
    state: { userLoggedOut: true },
    linkId: '024',
  },
  startReturn: {
    title: 'Start a Return',
    path: 'https://returns.narvar.com/express/returns',
    linkId: '025',
  },
  returnPolicy: {
    title: 'Returns and Exchanges Policy',
    path: '/g/returns-policy',
    linkId: '026',
  },
  ecc: {
    title: 'Express Credit Card',
    path: '/g/insider/ECC-instore ',
    linkId: '027',
  },
};

export default routes;
